import { ReactElement, useContext } from "react";
import { RootContext } from "./contexts";
import { LoadMoreIndicator as LoadMoreIndicatorComponent } from "../LoadMoreIndicator/LoadMoreIndicator";
import styles from "./TableView.module.less";

export type LoadMoreIndicatorProps = {
	isLoadingData: boolean;
	hasMoreItems: boolean;
	onRequestMoreItems(): void;
};

export const LoadMoreIndicator = (props: LoadMoreIndicatorProps): ReactElement | null => {
	const {
		isLoadingData,
		hasMoreItems,
		onRequestMoreItems
	} = props;

	const {
		containerWidth
	} = useContext(RootContext);

	if (!hasMoreItems && !isLoadingData) {
		return null;
	}

	return (
		<div
			className={styles.lazyLoadHandler}
			style={{width: containerWidth}}
		>
			<LoadMoreIndicatorComponent
				isLoadingData={isLoadingData}
				hasMoreItems={hasMoreItems}
				onRequestMoreItems={onRequestMoreItems}
			/>
		</div>
	);
};
LoadMoreIndicator.displayName = "TableView.LoadMoreIndicator";